// 店舗ページ(shops/show)のJS
import { carousel } from '@pc/components/Carousel'
import { initShopFloatingCta } from '@pc/components/ShopFloatingCta'
import { clickNearbyShop } from '@pc/components/ShopNearbyShops'

document.addEventListener('DOMContentLoaded', () => {
  // トラッキング・UIに必要なもの → 即実行
  clickNearbyShop()
  initShopFloatingCta()

  // カードのカルーセル(求人リスト/関連求人/過去に掲載していた求人例で共通)。
  // カード幅はloadを待たず確定するが、既存実装(prefectures等)に合わせてload後に初期化する
  const carouselWrappers = document.getElementsByClassName('js-shop-carousel-wrapper')
  if (carouselWrappers.length > 0) {
    window.addEventListener('load', () => {
      carousel({
        wrapperSelector: '.js-shop-carousel-wrapper',
        itemsSelector: '.js-shop-carousel-items',
        itemSelector: '.js-shop-carousel-item',
        leftCursorSelector: '.js-shop-carousel-prev',
        rightCursorSelector: '.js-shop-carousel-next',
        visibleItem: 3,
        gap: 24
      })
    })
  }
})
